import { authenticated_api } from './base';

export async function getChatNextSteps(sessionId, artifactId = null) {
  try {
    const path = `/chat/sessions/${encodeURIComponent(sessionId)}/messages/latest/suggestions`;
    return await authenticated_api.get(path, ...(artifactId ? [{ params: { artifact_id: artifactId } }] : []));
  } catch (error) {
    return error.response || null;
  }
}
